export const Resolution886ActionPlanTask = {
    ADMINISTRATIVE: 'ADMINISTRATIVE',
    ENGINEERING: 'ENGINEERING'
} as const;


export const Resolution886Result = {
    INITIAL: 'INITIAL',
    GENERAL: 'GENERAL'
} as const;

